<div
    class="h-full w-full card shadow border-2 overflow-visible"
    [ngClass]="{ 'indicator border-primary': selected() }"
    (click)="cardClicked.emit()"
>
    <div class="indicator-item badge badge-primary w-8 h-8" [ngClass]="{ hidden: !selected() }">
        <iota-icon src="flaticon/check.svg"> </iota-icon>
    </div>
    <div class="card-body p-3">
        <div class="flex flex-col gap-1">
            <span class="text-2xl">{{ user().fullName }} </span>
            <span class="mb-4">{{ user().email }}</span>
            <span>{{ user().companyName }}</span>
            <span>{{ user().officeName }}</span>
        </div>
    </div>
</div>
